/* It is possible to get to this component in Ember, but it is unclear whether it is actually used */
/* /locked => organization.lockedCode should be 'exceededPostingLimit' */
/* Via organization-locked.js controller => isExceededPostingLimit set to true & !!requiredAddons check disabled */
module.exports = Em.Component.extend({
    classNames: ['required-add-ons'],

    classNameBindings: ['dim'],

    organization: null,

    addons: null,

    dim: null,

    consolidatedCost: function() {
        var cost = this.get('addons').reduce(function(result, addon) {
            var type = addon.type
            var value = addon.value
            var price = addon.price

            if (type === 'integer' && value > 0) {
                result += price * value
            } else if (type === 'boolean' && value) {
                result += price
            }

            return result
        }, 0)

        this.send('changeCost', cost)

        return cost
    }.property('addons.@each.value'),

    consolidatedCostText: function() {
        var price = this.get('consolidatedCost')

        return Billy.moneyRecurring(price, 'DKK', '0,0', 'monthly')
    }.property('consolidatedCost'),

    actions: {
        changeCost: function(cost) {
            this.sendAction('consolidatedCostChanged', cost)
        }
    }
})
